import React from 'react';
const DownloadSVG = ({ color = 'white', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      className={className}
    >
      <path
        d="M1.28906 11.8226V19.3495C1.28906 19.9199 1.51564 20.4669 1.91894 20.8702C2.32224 21.2735 2.86924 21.5001 3.4396 21.5001H18.4934C19.0637 21.5001 19.6107 21.2735 20.014 20.8702C20.4173 20.4669 20.6439 19.9199 20.6439 19.3495V11.8226"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.55859 11.8226L10.9672 16.1237L15.3758 11.8226"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9688 1.5V13.8656"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadSVG;
